import { render, staticRenderFns } from "./rolepopup.vue?vue&type=template&id=faa58e96&scoped=true&"
import script from "./rolepopup.vue?vue&type=script&lang=js&"
export * from "./rolepopup.vue?vue&type=script&lang=js&"
import style0 from "./rolepopup.vue?vue&type=style&index=0&id=faa58e96&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faa58e96",
  null
  
)

export default component.exports